import {Modal, Col, Row, Form} from 'react-bootstrap';
import React, { useContext, useState} from 'react';
import { toast } from 'react-toastify';
import { UserContext } from '../../../UserContext';
import { validateFormFields } from '../../../utils';
import {FormInput} from '../../../components/formElements/FormInput';
import CommonService from '../../../services/CommonService';
import CurrencyInput from '../../formElements/CurrencyInput';
import BaseService from '../../../services/BaseService';

const EditAdtrAuthorization = (props) => {
    const user = useContext(UserContext);
    const {onModalClose, adtrAuthInfo, fiscalYrEndDate, cdiacNumber, tableType} = props;
    const [formErrors, setFormErrors] = useState({});
    const [adtrAuth, setAdtrAuth] = useState({...adtrAuthInfo});
    
    
    const handleAdtrAuthChange = e => {
        const { name } = e.target;
        let value = e.target.value;

        setAdtrAuth(prevState => ({
            ...prevState, [name]: value
        }))
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target.closest('form#edit-adtr-authorization');
        let formErrors = validateFormFields(form.elements);
        if(Object.keys(formErrors).length > 0) {
            setFormErrors(formErrors);
        } else {  
            setFormErrors({});
            var obj = {
                msgId: null,
                sysId: null,
                opr: "putAdtrAuthorizationUpdate",
                hdrStruct: null,
                queryParam: null,
                reqData: { 
                    "adtrAuth" : {
                        "adtrAuthorizationId":adtrAuth.adtrAuthorizationId,
                        "adtrId": adtrAuth.adtrId,
                        "authorizationId": adtrAuth.authorizationId,
                        "beginAmt": adtrAuth.beginAmt,
                        "lapsedAmt": adtrAuth.lapsedAmt,
                        "duringAmt": adtrAuth.duringAmt,
                        "authorityReplenishAmt": adtrAuth.authorityReplenishAmt,
                        "authorityReducedAmt": adtrAuth.authorityReducedAmt,
                        "lastUpdateUser": CommonService.getUserName(user)
                    },
                    "tableType": tableType
                },
            };
        
            BaseService.processRequest(obj)
                .then((result) => {
                    if (result.data.errors && result.data.errors.length > 0){
                            toast.error(result.data.errors[0].message)
                    }
                    else{
                        toast.success("ADTR Authorization updated successfully!");
                        onModalClose();
                    }

                });
        }
    }
    
    return (
        <Modal show={true} backdrop="static" onHide={onModalClose}>
            <Modal.Header closeButton><h3>Edit ADTR Authorization</h3></Modal.Header>
            <Modal.Body>
            <form id="edit-adtr-authorization">
                <div className="contactForm">
                    <Row>
                            <Col md={6} className="control">
                                <FormInput
                                    label="CDIAC Number"
                                    type="text"
                                    value={cdiacNumber}
                                    disabled
                                    readOnly
                                />
                            </Col>
                            <Col md={6} className="control">
                                <FormInput
                                    label="ADTR Fiscal Year End Date"
                                    type="text"
                                    value={CommonService.dateFormatter(fiscalYrEndDate)}
                                    disabled
                                    readOnly
                                />
                            </Col>
                           
                    </Row>
                    <Row>
                            <Col md={6} className="control">
                                <FormInput
                                    label="Authorization Name"
                                    type="text"
                                    value={adtrAuth.authorizationName}
                                    disabled
                                    readOnly
                                />
                            </Col>
                            <Col md={6} className="control">
                                <FormInput
                                    label="Authorization Id"
                                    type="text"
                                    value={adtrAuth.authorizationId}
                                    disabled
                                    readOnly
                                />
                            </Col>
                           
                    </Row>
                    <Row>
                            <Col md={6} className="control">
                                <FormInput
                                    label="Authorization Date"
                                    type="text"
                                    value={CommonService.dateFormatter(adtrAuth.authorizationDate)}
                                    disabled
                                    readOnly
                                />
                            </Col>
                            <Col md={6} className="control">
                                <FormInput
                                    label="Authorization Original Amount"
                                    type="text"
                                    value={CommonService.currencyFormatter(adtrAuth.originalAuthorizedAmt)}
                                    disabled
                                    readOnly
                                />
                            </Col>
                    </Row>
                    <Row>
                        <Col md={4} className="control">
                                    <span className="required">* </span>
                                    <CurrencyInput
                                    placeholder="0.00"
                                    label="Begin Amount"
                                    name="beginAmt"
                                    type="text"
                                    onChange={(e) => handleAdtrAuthChange(e)}
                                    value={adtrAuth.beginAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                                {formErrors['beginAmt'] && <span className="error">{formErrors['beginAmt']}</span>}
                        </Col>
                        <Col md={4} className="control">
                            <span className="required">* </span>
                                <CurrencyInput
                                    placeholder="0.00"
                                    label="During Amount"
                                    name="duringAmt"
                                    type="text"
                                    onChange={(e) => handleAdtrAuthChange(e)}
                                    value={adtrAuth.duringAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                            {formErrors['duringAmt'] && <span className="error">{formErrors['duringAmt']}</span>}
                        </Col> 
                        <Col md={4} className="control">
                                <span className="required">* </span>
                                <CurrencyInput
                                    placeholder="0.00"
                                    label="Authority Reduced Amount"
                                    name="authorityReducedAmt"
                                    type="text"
                                    onChange={(e) => handleAdtrAuthChange(e)}
                                    value={adtrAuth.authorityReducedAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                                {formErrors['authorityReducedAmt'] && <span className="error">{formErrors['authorityReducedAmt']}</span>}

                        </Col>
                    </Row>
                    <Row>                  
                        <Col md={6} className="control">
                            <span className="required">* </span>
                                <CurrencyInput
                                    placeholder="0.00"
                                    label="Authority Replenish Amount"
                                    name="authorityReplenishAmt"
                                    type="text"
                                    onChange={(e) => handleAdtrAuthChange(e)}
                                    value={adtrAuth.authorityReplenishAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                            {formErrors['authorityReplenishAmt'] && <span className="error">{formErrors['authorityReplenishAmt']}</span>}
                        </Col>
                        <Col md={6} className="control">
                                 <span className="required">* </span>
                                <CurrencyInput
                                    placeholder="0.00"
                                    label="Lapsed Amount"
                                    name="lapsedAmt"
                                    type="text"
                                    onChange={(e) => handleAdtrAuthChange(e)}
                                    value={adtrAuth.lapsedAmt}
                                    validations={["required", "max:999999999999.99"]}
                                />
                                {formErrors['lapsedAmt'] && <span className="error">{formErrors['lapsedAmt']}</span>}
                        </Col>
                    </Row>
                </div>
                <div className="btn-div">
                <div className="fright">
                    <button type="button" className="custom-button-secondary  btn-secondary" onClick={onModalClose}>Cancel</button>{" "}
                    <button className="custom-button" type="button" onClick={(e)=>handleSubmit(e)}>Update ADTR Authorization</button>
                    </div>
                </div>
            </form>                
            </Modal.Body>
        </Modal>
    )
}

export default EditAdtrAuthorization
